const oidc = {
    aborted: '使用者終止了互動。',
    invalid_scope: '無效的範圍: {{scope}}。',
    invalid_token: '權杖無效',
    invalid_client_metadata: '無效的用戶端元數據',
    insufficient_scope: '權杖缺少範圍 `{{scope}}`。',
    invalid_request: '請求無效',
    invalid_grant: '授權請求無效',
    invalid_issuer: '發行者無效。',
    invalid_redirect_uri: '無效返回連結, 该redirect_uri未被此應用註冊。',
    access_denied: '拒絕訪問',
    invalid_target: '請求資源無效',
    unsupported_grant_type: '不支援的grant_type',
    unsupported_response_mode: '不支援的response_mode',
    unsupported_response_type: '不支援的response_type',
    provider_error: '開放身分連接（OIDC）內部錯誤: {{message}}',
    server_error: '發生未知的開放身分連接（OIDC）錯誤。請稍後再試。',
    provider_error_fallback: '發生了一個開放身分連接（OIDC）錯誤: {{code}}。',
    custom_claims_script_error: '自訂宣告腳本錯誤：{{error_description}}',
    key_required: '至少需要一個金鑰。',
    key_not_found: '未找到識別碼為 {{id}} 的金鑰。',
    only_previous_key_can_be_deleted: '僅可刪除上一個金鑰。',
    invalid_session_payload: '無效的會話負載。',
    session_not_found: '未找到會話。',
    invalid_session_account_id: '會話accountId不匹配。',
    failed_to_revoke_grant: '撤銷授權失敗。',
    failed_to_cleanup_session_authorization: '清理會話授權記錄失敗。',
};
export default Object.freeze(oidc);
